module.exports = __webpack_public_path__ + "live_chat_nolive-79dc86f9.png";